// Bridges the axios interceptor (src/utils/auth.js, outside React) to the React
// tree for a 410 workspace_archived: ONE workspace was archived while this
// session was inside it, but the account is live. Unlike account_archived
// (ArchivedAccountGate, full-screen lockout) there is somewhere to go — another
// live workspace, or the no-workspace screen — see WorkspaceArchivedListener.
let listeners = [];

export const notifyWorkspaceArchived = (payload) => {
  listeners.slice().forEach((fn) => fn(payload));
};

export const subscribeWorkspaceArchived = (fn) => {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
};
